import {
  BellRing,
  Database,
  DatabaseBackup,
  History,
  Mail,
  ScrollText,
  Wrench,
} from 'lucide-react';
import { TabbedPage } from '../components/common/TabbedPage';

/** The administrators' tools that used to be separate menu entries, as one page. */
export const SYSTEM_TABS = [
  { path: '/admin/mail-log', label: 'Mail log', icon: <Mail size={16} /> },
  { path: '/admin/audit-logs', label: 'Audit log', icon: <History size={16} /> },
  { path: '/admin/logs', label: 'Logs', icon: <ScrollText size={16} /> },
  { path: '/admin/log-alerts', label: 'Alerts', icon: <BellRing size={16} /> },
  { path: '/admin/backups', label: 'Backups', icon: <DatabaseBackup size={16} /> },
  { path: '/admin/sql-client', label: 'SQL client', icon: <Database size={16} /> },
];

export function SystemPage() {
  return (
    <TabbedPage
      title="System"
      icon={<Wrench size={24} className="text-primary-600" />}
      tabs={SYSTEM_TABS}
    />
  );
}
